// @material-ui/icons
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import IndividualTenantTab from '../components/individual/IndividualTenantTab'
import IndividualHSV from '../components/individual/IndividualHSV'
import PersonIcon from '@material-ui/icons/Person'

export const individualTenantRoutes = [
  {
    path: '/dashboard/me',
    name: 'Mein Account',
    icon: PersonIcon,
    component: IndividualTenantTab,
  },
  {
    path: '/dashboard/departments/current',
    name: 'HSV',
    icon: AssignmentIndIcon,
    component: IndividualHSV,
  },
]
